import { Component, OnInit, ViewChild } from '@angular/core';
import { RenewalChoosePlan } from '../../models/renewal-choose-plan';
import { Router } from '@angular/router';
import { RenewalCogService } from 'services/renewalcog.service';
import { PlanSelectedDialogComponent } from '../plan-selected-dialog/plan-selected-dialog.component'
import { MatDialog } from '@angular/material/dialog';
import { ErrorService } from 'services/error.service';

@Component({
  selector: 'app-choose-plan-cog',
  templateUrl: './choose-plan-cog.component.html',
  styleUrls: ['./choose-plan-cog.component.css'],
  entryComponents: [PlanSelectedDialogComponent],
})
export class ChoosePlanCogComponent implements OnInit {

  model: RenewalChoosePlan;
  confirmPlan: boolean;
  displaySuccessMsg: boolean;
  planType: string = null;
  planChosen: boolean = false;

  constructor(
    private renewalService: RenewalCogService, private errorService: ErrorService,
    public router: Router, public dialog: MatDialog
  ) {
    this.model = new RenewalChoosePlan();

    const RenewalKey = localStorage.getItem('RenewalKey');

    if (RenewalKey !== undefined && RenewalKey !== null) {

      this.model.LeaseRenewalKey = Number(RenewalKey);

      this.renewalService.getChosenPlanInfo(this.model)
        .subscribe(res => this.getChosenPlanInfo(res), err => this.errorService.showError(this.renewalService.handleError(err)));

    } else {
      this.renewalService.handleError("Error - unable to verify renewal token.");
    }

  }

  ngOnInit() {
    this.confirmPlan = false;
    this.displaySuccessMsg = false;
  }

  openPlanSelectDialog() {
    localStorage.setItem('emailAddress', this.model.SentEmail);

    const dialogRef = this.dialog.open(PlanSelectedDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      localStorage.removeItem('emailAddress');
      this.logOut();
    });
  }


  async getChosenPlanInfo(info: RenewalChoosePlan) {
    this.model = info;

    if (this.model.PremierPlan.ChosenPlan) {
      this.planType = "premier";
      this.planChosen = true;
    }
    else if (this.model.PreferredPlan.ChosenPlan) {
      this.planType = "preferred";
      this.planChosen = true;
    }
    else if (this.model.FlexiblePlan.ChosenPlan) {
      this.planType = "flexible";
      this.planChosen = true;
    }
  }

  onSubmit() {
    this.confirmPlan = true;
    this.model.PremierPlan.ChosenPlan = false;
    this.model.PreferredPlan.ChosenPlan = false;
    this.model.FlexiblePlan.ChosenPlan = false;

    if (this.planType == "premier") {
      this.model.PremierPlan.ChosenPlan = true;
    }
    if (this.planType == "preferred") {
      this.model.PreferredPlan.ChosenPlan = true;
    }
    if (this.planType == "flexible") {
      this.model.FlexiblePlan.ChosenPlan = true;
    }

    this.renewalService.updateChosenPlanInfo(this.model)
      .subscribe(res => this.openPlanSelectDialog(),
        err => this.errorService.showError(this.renewalService.handleError(err)));
  }

  logOut() {
    localStorage.removeItem('RenewalKey');
    localStorage.removeItem('YardiKey');

    this.router.navigate(['renewalcog/renewal-dashboard']);
  }

}
